import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Execution.module.css';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const execution = (props) => {
    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (props.selected === 'NewExecutionList') {
        header_icon = (<div className={classes.AddCircle}><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }
    const chosenStyle = {boxShadow: props.selectedInUrl ? '0px 0px 4px 2px #52abcc' : 'none'};

    return (
        <div className={"card "+ classes.Execution + ' ' + (props.selected==='selected' ? classes.selected : '')}  style={chosenStyle}  onClick={props.clicked}>

            <OverlayTrigger
                trigger={['hover', 'focus']}
                rootClose
                rootCloseEvent="click"
                key={"info_link_"+props.id}
                placement='top'
                overlay={
                    <Popover id='exercise_step-notes'>
                        <Popover.Title as="h3">Execution Seed:</Popover.Title>
                        <Popover.Content className="game-description">
                            {props.seed + ((props.description) ? " - " + props.description : "")}
                        </Popover.Content>
                    </Popover>
                }
            >
                <h4 className={"card-header " + classes.cardHeader}>Seed: {props.seed} {header_icon}</h4>
            </OverlayTrigger>

            <div className={"card-body " + classes.cardBody}>
                <div className={"card-text " + classes.cardText}>

                    Exercise completed By: {props.authors} <br/>
                    On: {props.date}
                </div>
            </div>
        </div>
    );
};

export default execution;